import { Col, Container, Row, Tab, Nav } from "react-bootstrap";

import ProjectCards from "../../components/ProjectCards/ProjectCards";

// projects - javascript
import calculatorImg from "../../assets/images/projects/Calculator.png"
import morseImg from "../../assets/images/projects/Morse-Code-Translator.png"
import quizImg from "../../assets/images/projects/Quiz-API.png";
import yahtzeeImg from "../../assets/images/projects/Yahtzee.png"
// projects - react
import ticketTrackerImg from "../../assets/images/projects/Ticket-tracker.png";
import punkApiImg from "../../assets/images/projects/Punk-API.png";
import memoryImg from "../../assets/images/projects/Memory-game.png"
import parksImg from "../../assets/images/projects/Parks.png"

// projects - java
import hangmanImg from "../../assets/images/projects/Hangman.png"
import marvelSqlImg from "../../assets/images/projects/MarvelSQL.png"

import "./Projects.scss";

const Projects = () => {
  const javascript = [
    {
      title: "Simple Calculator",
      description: "First Javascript project, simple calculator, which has most of the functions used in the simple version of iPhone's calculator. Works with mouse clicking and with the keyboard.",
      imgUrl: calculatorImg,
      link: "https://dorbia.github.io/calculator-js/",
      ghLink: "https://github.com/DorBia/calculator-js",
    },
    {
      title: "Morse Code Translator",
      description: "Basic morse code translator, which will translate on each key press, and will work on each own both ways, no buttons needed. It also plays sound.",
      imgUrl: morseImg,
      link: "https://dorbia.github.io/morse-code-translator-js/",
      ghLink: "https://github.com/DorBia/morse-code-translator-js",

    },
    {
      title: "Quiz App",
      description: "Quiz app I have made with using open trivia database API, with few different categories to choose from. It keeps track of the score, as well as showing the best score in the session.",
      imgUrl: quizImg,
      link: "https://dorbia.github.io/quiz-js/",
      ghLink: "https://github.com/DorBia/quiz-js",

    },
    {
      title: "Yahtzee Game",
      description: "Automated version of Yahtzee game, which is being played for years now around the globe. The score and everything is added automatically so you won't have to worry about it.",
      imgUrl: yahtzeeImg,
      link: "https://dorbia.github.io/yahtzee-js/",
      ghLink: "https://github.com/DorBia/yahtzee-js",

    },
  ];

  const react = [
    {
      title: "Ticket Tracker",
      description: "First project using React. Simple ticket tracker, which let's you track how many tickets each person has. It's possible to add new employees as well as delete them and search through them by both the name and the position.",
      imgUrl: ticketTrackerImg,
      link: "https://dorbia.github.io/ticket-tracker/",
      ghLink: "https://github.com/DorBia/ticket-tracker",
    },
    {
      title: "Punk API",
      description: "Simple website to list BrewDog beers by using the Punk API. It has main page with all 325 beers listed, which you can search through, filter and sort at the same time. As well as change the theme from blue to orange. It also has a single page for each beer, that will show you more information about the beer.",
      imgUrl: punkApiImg,
      link: "https://dorbia.github.io/punk-api/",
      ghLink: "https://github.com/DorBia/punk-api",
    },
    {
      title: "Marvel Memory Game",
      description: "Memory game made in react. It has 3 different difficulties to choose from, it shows how many turns it took to finish at the end of each play.",
      imgUrl: memoryImg,
      link: "https://memory-22c92.web.app",
      ghLink: "https://github.com/DorBia/marvel-memory",
    },
    {
      title: "Parks and Recreation",
      description: "Full Stack app with CRUD, hosted on Firebase (front-end) and GCP (back-end). Front-end created with react and bootstrap, back-end created with Spring Boot and MySQL. Project has 3 tables connected to each other (eg. by adding character to episode, it's also adding episode to the character).",
      imgUrl: parksImg,
      link: "https://parks-and-rec-ae5dc.web.app",
      ghLink: "https://github.com/DorBia/Parks-And-Rec-full-stack",
    },
  ]

  const java = [
    {
      title: "Hangman",
      description: "Simple hangman game made using OOP, played in the console - using colors to make it more interesting.",
      imgUrl: hangmanImg,
      ghLink: "https://github.com/DorBia/hangman",

    },
    {
      title: "Marvel SQL",
      description: "My first project using Java with Spring Boot to connect to the database's table of Marvel Characters. It's possible to add, delete, update, and search through characters.",
      imgUrl: marvelSqlImg,
      ghLink: "https://github.com/DorBia/QAProject-Marvel",

    },
  ]

  const everything = [...javascript, ...react, ...java]
  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <div>
              <h2>Projects</h2>
              <p>Over the last 12 weeks, I have created quite few projects, which I am really proud of. <br/>
                Hover on each project for more details! <br/>
                Click on the Rocket icon to launch the app or the Code icon to see the code.
              </p>
            </div>
            <Tab.Container id="projects-tabs" defaultActiveKey="first">
              <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                <Nav.Item>
                  <Nav.Link eventKey="first">Vanilla JS</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">React</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">Java</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="fourth">Everything</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="first" id="first">
                  <Row>
                    {javascript.map((basic, index) => {
                      return <ProjectCards key={index} {...basic} />;
                    })}
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <Row>
                    {react.map((react, index) => {
                      return <ProjectCards key={index} {...react} />;
                    })}
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <Row>
                  {java.map((java, index) => {
                      return <ProjectCards key={index} {...java} />;
                    })}
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="fourth">
                  <Row>
                    {everything.map((project, index) => {
                      return <ProjectCards key={index} {...project} />;
                    })}
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Projects;
